import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'strech',
    minHeight: '100%',
    overflow: 'auto',
  },
  panelsContainer: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
  },
  fadeInContainer: {
    animation: `${fadeInKeyframes} 0.3s ease-out`,
  },
});
